import React from 'react';
import useLinksData from '../hooks/useLinksData';

const Legals = () => {

    const { getLinks } = useLinksData();
    const links = getLinks();

    return (
        <div className="legals-container">
            <div className="main-container">
                <small>(*)</small> <a href={links.tnc_by_model_page ? links.tnc_by_model_page : '#'} className="link-arrow" target="_blank">Ver Términos & Condiciones <i className="icon chevron-strong"></i></a>
            </div>
        </div>
    )
}

export default Legals;